import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES: string[] = ['Code', 'Description'];

export const StandardTextDropdowns = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options: standardTextsOptions, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /promptValues/{windowId}',
    labelAttribute: 'textLine1',
    valueAttribute: 'textNo',
    params: {
      windowId: 'standardTexts',
    },
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={standardTextsOptions} columnNames={COLUMN_NAMES} />;
};
